module.exports = (__webpack_require__(8832))(27760);